import { render } from "./TopBar.vue?vue&type=template&id=03ef29ae&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=03ef29ae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-03ef29ae"

export default script